import { measuredUsingConfigFor as wrap } from 'Components/Worksheets/Core/Helpers/configHelpers';
import { pathAsArray, pathAsString } from 'Lib/Object/Path/shared';

const getMeasuredUsingConfig = (prefix: string) => {
  const compactionBalance = wrap(`${prefix}.Equipment.CompactionBalance`);
  const tareMassBalance = wrap(`${prefix}.Equipment.TareMassBalance`);
  const materialRetainedBalance = wrap(`${prefix}.Equipment.MaterialRetainedBalance`);
  return {
    [`${prefix}.Equipment.MouldMass`]: compactionBalance,
    [`${prefix}.Equipment.Moulds.Moulds.Mass`]: compactionBalance,
    [`${prefix}.TestPortions.MouldMass`]: compactionBalance,
    [`${prefix}.TestPortions.PortionMass`]: compactionBalance,
    [`${prefix}.TestPortions.WetSoilAndMouldMass`]: compactionBalance,
    [`${prefix}.TestPortions.WaterAdded`]: compactionBalance,
    [`${prefix}.TestPortions.PortionMassAfterWaterAdded`]: compactionBalance,
    [`${prefix}.Preparation.TareAndTotalSampleMass`]: tareMassBalance,
    [`${prefix}.Preparation.TareMass`]: tareMassBalance,
    [`${prefix}.Preparation.CumulativeMassRetainedOn20mmSieve`]: materialRetainedBalance,
    [`${prefix}.Preparation.CumulativeMassRetainedOn37_5mmSieve`]: materialRetainedBalance,

    // Moisture Determination needs to use the specific balance for each portion.
    // TODO: This is a fairly awkward workaround for issues providing config for an array of unknown length
    // where it varies by index.
    // We take the full name (which will include the index of the portion) and work out the balance path from that.
    [`${prefix}.TestPortions.MoistureDetermination.DryingTray.ContainerMass`]: ({ name }: { name: string }) =>
      wrap(pathAsString([...pathAsArray(name).slice(0, -2), 'Equipment.Balance'])),
    [`${prefix}.TestPortions.MoistureDetermination.DryingTray.WetSoilAndContainerMass`]: ({ name }: { name: string }) =>
      wrap(pathAsString([...pathAsArray(name).slice(0, -2), 'Equipment.Balance'])),
    [`${prefix}.TestPortions.MoistureDetermination.DryingTray.DryMassReadings.DrySoilAndContainerMass`]: ({
      name,
    }: {
      name: string;
    }) => wrap(pathAsString([...pathAsArray(name).slice(0, -4), 'Equipment.DryMassBalance'])),
  };
};

export default getMeasuredUsingConfig;
